export default __webpack_public_path__ + "static/media/GuidLogo.a0846b9f.png";